import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Generate() {
  const [topics, setTopics] = useState([]);
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/ai/topics").then(({ data }) => setTopics(data)).catch(() => {});
  }, []);

  const generate = async () => {
    if (!topic) {
      toast.error("Pick a topic first.");
      return;
    }
    setLoading(true);
    try {
      const { data: gen } = await api.post("/ai/generate", { topic });
      const { data: sess } = await api.post("/sessions/start", {
        source: "ai",
        title: gen.title,
        content: gen.content,
      });
      navigate(`/reading/${sess.session_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Generation failed. Try another topic.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 sm:py-24">
        <div className="text-[10px] tracking-[0.4em] uppercase text-ember-500 mb-4">AI Generated Reading</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3" data-testid="generate-title">
          Forge an original essay.
        </h1>
        <p className="text-sm text-forge-100/60 mb-10 max-w-2xl">
          Choose a domain. ThoughtSmith™ will write a 500–800 word original, factually grounded essay — never excerpted from copyrighted texts.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
          {topics.map((t) => (
            <button
              key={t}
              onClick={() => setTopic(t)}
              className={`text-left px-5 py-4 border rounded-sm transition-all ${topic === t ? "border-ember-500 bg-forge-800 text-ember-400" : "border-white/10 hover:border-ember-500/60 text-forge-100/80"}`}
              data-testid={`topic-${t.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <span className="font-serif text-lg">{t}</span>
            </button>
          ))}
        </div>

        <button
          onClick={generate}
          disabled={!topic || loading}
          className="px-7 py-3 bg-ember-500 hover:bg-ember-400 disabled:opacity-60 text-forge-900 font-semibold tracking-wide rounded-sm transition-all"
          data-testid="generate-submit"
        >
          {loading ? "Striking the iron…" : "Generate Essay"}
        </button>
        {loading && (
          <p className="mt-6 text-xs uppercase tracking-[0.25em] text-forge-100/40 animate-pulse">This may take 20–40 seconds.</p>
        )}
      </main>
    </div>
  );
}
